import segmentPlugin from "@analytics/segment";
import Analytics from '@analytics/segment';
import React from "react";
import { PROJECT_NAME } from "../constants/common";

// Initialize Segment instance with write key
const analytics = Analytics({
  app: PROJECT_NAME,
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEGMENT_PUBLIC_KEY,
    }),
  ],
});

export const AnalyticsContext = React.createContext(analytics);

export const AnalyticsContextProvider = ({ children }) => {
  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};
